<template>
  <b-row no-gutters id="cancel-order-section">
    <b-col sm="12" md="4">
      <h6 class="main-label">Cancel Order Button</h6>
    </b-col>
    <b-col style="margin-top: -18px; position: relative">
      <label for="cancel_order_enable" class="d-flex align-items-center">
        <span class="mr-3">Enable</span>
        <switches v-model="formData.cancel_order_enable" theme="custom" color="primary" type-bold="true"
          text-enabled="On" text-disabled="Off" :style="{ 'top': '2px' }"></switches>
      </label>
      <template v-if="formData.cancel_order_enable">
        <CancelOrderVisibilitySettings ref="cancelVisibilitySettings" :isEnabled="formData.cancel_order_enable"
          :visibilitySettings="{ disable_cancel: formData.disable_cancel, disable_cancel_seconds: formData.disable_cancel_seconds }" />
        <label for="cancellation_reasons" class="top-label font-weight-bold">Reason/s</label>
        <b-row no-gutters v-for="(option, option_index) in formData.cancellationOptions" :key="`option_${option_index}`"
          class="align-items-center">
          <b-col cols="10">
            <b-form-group>
              <template slot="label">
                <b style="font-size: 14px">Option {{ option_index + 1 }}</b>
              </template>
              <b-form-select v-model="formData.cancellationOptions[option_index]" :class="{
                'text-muted':
                  !formData.cancellationOptions[option_index].value,
              }" v-if="
                formData.cancellationOptions[option_index]
                  .identifier !== 0
              ">
                <option v-for="(reason, reason_index) in cancellationReasons"
                  :key="`reason_for_cancellation_${reason_index}`" :value="reason" :disabled="(!reason.value && reason.value !== '') ||
                    (formData.cancellationOptions
                      .map((reason) => reason.value)
                      .includes(reason.value) &&
                      reason.value !== '')
                    ">
                  {{
                    reason.value === 0 || !reason.value
                      ? reason.placeholder
                      : reason.value
                  }}
                </option>
              </b-form-select>
              <b-form-input v-else maxlength="100" :ref="`custom_reason_${option_index}`"
                :name="`custom_reason_${option_index}`" :value="option.value">
              </b-form-input>
              <b-form-input type="text" hidden :state="Object.keys(cancelOptionErrors).includes(
                option_index
              )
                "></b-form-input>
              <b-form-invalid-feedback :state="Object.keys(cancelOptionErrors).includes(
                option_index
              )
                ">
                {{ cancelOptionErrors[option_index] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col cols="2" :class="['text-left', { 'offset-top': !!cancelOptionErrors[option_index] }]">
            <b-button class="bg-transparent border-0 p-0 shadow-none ml-2" @click="removeCancelOption(option_index)"
              v-if="formData.cancellationOptions.length > 1">
              <img src="../../assets/images/actions/delete.svg" alt="Delete Icon" class="mt-2"
                style="cursor: pointer" />
            </b-button>
          </b-col>
        </b-row>
        <b-button class="bg-transparent p-0 border-0 shadow-none mt-3" @click="
          formData.cancellationOptions.push({
            value: null,
            placeholder: 'Select a reason',
            identifier: null,
          })
          " :disabled="formData.cancellationOptions.length >= 5">
          <img class="branch-add-button d-inline-block" src="../../assets/images/icons/add.svg" alt="Add Icon" />
          <label for="new-option" style="cursor: pointer" class="add-branch-label ml-2 d-inline-block align-middle">
            Add New Option
          </label>
        </b-button>
      </template>
    </b-col>
  </b-row>
</template>

<script>
import { defineComponent, nextTick } from "@vue/composition-api/";
import Switches from "vue-switches";
import CancelOrderVisibilitySettings from "./CancelOrderVisibilitySettings.vue";

export default defineComponent({
  props: ["formData", "cancellationReasons", "cancelOptionErrors"],
  components: { Switches, CancelOrderVisibilitySettings },
  setup(props, { root, refs }) {
    const removeCancelOption = (optionIndex) => {
      props.formData.cancellationOptions.map((option, index) => {
        if (option.identifier === 0) {
          option.value = refs[`custom_reason_${index}`][0].$el.value;
        }
      });
      nextTick(() => {
        delete props.cancelOptionErrors[optionIndex];
        props.formData.cancellationOptions.splice(optionIndex, 1);
      });
    };

    return {
      removeCancelOption
    }
  }
});
</script>

<style lang="scss" scoped>
.offset-top {
  position: relative;
  top: -0.65rem;
}
</style>

<style lang="scss">
#cancel-order-section {
  .top-label {
    font-size: 14px;
    color: #222D37;
  }
}
</style>
